import React from 'react';

const WhyChoose: React.FC = () => {
  return (
    <section className="why-choose">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Why Choose Traveze?</h2>
          <p className="section-subtitle">
            Experience the future of travel planning with our cutting-edge features and personalized approach
          </p>
        </div>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon ai-icon"></div>
            <h3 className="feature-title">AI-Powered Planning</h3>
            <p className="feature-description">
              Smart algorithms that understand your travel preferences and create personalized itineraries just for you
            </p>
            <ul className="feature-list">
              <li>Smart Recommendations</li>
              <li>Real-time Updates</li>
              <li>Preference Learning</li>
            </ul>
          </div>
          <div className="feature-card">
            <div className="feature-icon global-icon"></div>
            <h3 className="feature-title">Global Coverage</h3>
            <p className="feature-description">
              Access to destinations worldwide with local insights and authentic experiences in every corner
            </p>
            <ul className="feature-list">
              <li>200+ Countries</li>
              <li>Local Expertise</li>
              <li>Hidden Gems</li>
            </ul>
          </div>
          <div className="feature-card">
            <div className="feature-icon custom-icon"></div>
            <h3 className="feature-title">Custom Itineraries</h3>
            <p className="feature-description">
              Personalized day-by-day travel plans tailored to your interests, pace, and style
            </p>
            <ul className="feature-list">
              <li>Flexible Planning</li>
              <li>Activity Matching</li>
              <li>Smart Scheduling</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose; 